var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1 C5.029,1 1,5.029 1,10 C1,14.971 5.029,19 10,19 C14.971,19 19,14.971 19,10 C19,5.029 14.971,1 10,1 M20,10 C20,15.523 15.523,20 10,20 C4.477,20 0,15.523 0,10 C0,4.477 4.477,0 10,0 C15.523,0 20,4.477 20,10",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4991,9.9993 C11.4991,9.4493 11.0491,8.9993 10.4991,8.9993 L9.4991,9.0003 C8.9491,9.0003 8.4991,9.4503 8.4991,10.0003 L8.5011,15.0003 C8.5011,15.5503 8.9511,16.0003 9.5011,16.0003 L10.5011,15.9993 C11.0511,15.9993 11.5011,15.5493 11.5011,14.9993 L11.4991,9.9993 Z M10.4991,9.9993 L10.5011,14.9993 L9.5011,15.0003 L9.4991,10.0003 L10.4991,9.9993 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4991,5.9996 C11.4991,5.4496 11.0491,4.9996 10.4991,4.9996 L9.4991,5.0006 C8.9491,5.0006 8.4991,5.4506 8.4991,6.0006 L8.5011,7.0006 C8.5011,7.5506 8.9511,8.0006 9.5011,8.0006 L10.5011,7.9996 C11.0511,7.9996 11.5011,7.5496 11.5011,6.9996 L11.4991,5.9996 Z M10.4991,5.9996 L10.5011,6.9996 L9.5011,7.0006 L9.4991,6.0006 L10.4991,5.9996 Z",
    id: "Fill-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.bb8792a433f5d98dec7282b732789169.svg";
export { ForwardRef as ReactComponent };